import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCGoI9Lf--L71zHLH3qHuaLbfP04ga3_Wg",
    authDomain: "qrcodecustomer.firebaseapp.com",
    projectId: "qrcodecustomer",
    storageBucket: "qrcodecustomer.firebasestorage.app",
    messagingSenderId: "985701680623",
    appId: "1:985701680623:web:bc7b8dfa41b92a7b28e21a",
    measurementId: "G-M6CGWRWZ53"
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
